import { useSetTimeout } from '@fluentui/react-hooks';
import { useState } from 'react';
/** How long to run transition animations for theme changes. */
const THEME_TRANSITION_DURATION = 1700;
/**
 * State manager hook that controls timing for the theme transitioning period.
 */
export const useAnimationState = () => {
    const [isTransitioning, setIsTransitioningState] = useState(false);
    const { clearTimeout, setTimeout } = useSetTimeout();
    const [id, setId] = useState(null);
    const setIsTransitioning = (newIsTransitioning = true) => {
        // Update to the new transition state
        setIsTransitioningState(newIsTransitioning);
        if (id) {
            clearTimeout(id);
            setId(null);
        }
        // If the new state is true (we're transitioning), set a timeout to end the transition.
        if (newIsTransitioning) {
            const newId = setTimeout(() => {
                setIsTransitioningState(false);
            }, THEME_TRANSITION_DURATION);
            setId(newId);
        }
    };
    return {
        isTransitioning,
        setIsTransitioning,
    };
};
